import { Link } from 'react-router-dom';
import { comics } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Comics() {
  return (
    <section className="bg-white">
      <div className="section-padding">
        <SectionHeading
          index="03"
          eyebrow="热门推荐"
          title="热门漫画抢先看"
          subtitle="精选全网热门作品，无论你喜欢什么类型，这里总有一部适合你。"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 md:gap-6 max-w-6xl mx-auto">
          {comics.map((comic, i) => (
            <ScrollReveal key={comic.title} delay={i * 60}>
              <div className="group">
                {/* 漫画封面描边框 */}
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden border-2 border-gray-900 shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1.5 transition-all duration-300 bg-white mb-3">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  {/* 角标序号 */}
                  <span className="absolute top-2 left-2 w-7 h-7 rounded-md border-2 border-gray-900 bg-white text-xs font-bold text-pink-500 flex items-center justify-center">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="text-sm font-bold text-gray-900 group-hover:text-pink-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-gray-400 mt-1">{comic.category}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link to="/hot-comics" className="btn-comic">
            查看更多热门漫画 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}